export const ProfileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.05 9.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1.25 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.5 12c0 2.82-1.111 5.38-2.92 7.266v.002l-.003.001A10.47 10.47 0 0 1 12 22.5a10.47 10.47 0 0 1-7.577-3.23l-.003-.002v-.002A10.47 10.47 0 0 1 1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12M12 21.25c2.34 0 4.477-.869 6.106-2.302l-.48-1.198c-.454-1.136-.63-1.55-.9-1.847a2.4 2.4 0 0 0-.927-.628c-.376-.14-.825-.15-2.049-.15h-3.5c-1.223 0-1.673.01-2.049.15a2.4 2.4 0 0 0-.928.628c-.27.297-.445.71-.9 1.847l-.48 1.198A9.22 9.22 0 0 0 12 21.25m7.063-3.276A9.2 9.2 0 0 0 21.25 12a9.25 9.25 0 1 0-16.313 5.974l.322-.804c.39-.978.648-1.622 1.09-2.108a3.6 3.6 0 0 1 1.415-.958c.615-.23 1.308-.23 2.361-.229h3.75c1.053 0 1.746 0 2.361.229.542.202 1.027.53 1.416.958.44.486.698 1.13 1.09 2.108z"
      clipRule="evenodd"
    ></path>
  </svg>
);
